<template>
    <div class="container">
        <div class="topView">
            <div class="topView_top">
                <img class="topView_top_icon" src="../../assets/images/icon_order_unpaid.png"/>
                <span class="topView_top_span" v-if ="details.actType ==1 &&( details.tradeStatus ==5 ||details.tradeStatus ==6)" >已提货</span>
                <span class="topView_top_span" v-if ="details.actType ==1 &&( details.tradeStatus ==3 ||details.tradeStatus ==4)" >待提货</span>
            </div>
            <div class="topView_body">
                <span  class="topView_body_span" v-if ="details.actType ==1 &&( details.tradeStatus ==5 ||details.tradeStatus ==6)">期待为您再次服务~</span>
                <span  class="topView_body_span" v-if ="details.actType ==1 &&( details.tradeStatus ==3 ||details.tradeStatus ==4)">请到指定地点自提</span>
            </div>
        </div>
        <div class="addressView" v-if="details.templateType!='1'">
            <div class="addressViewBG">
                <div class="addressView_left">
                    <div class="addressView_left_div">
                        <img class="addressView_left_icon" src="../../assets/images/icon_ziti_address_icon.png"/>
                        <span class="addressView_left_span1">自提地址</span>
                    </div>
                    <span class="addressView_left_span2" >{{selfLiftingAddress}}</span>
                </div>
                <div class="addressView_line"></div>
                <div class="addressView_right" @click="copyTradeCodeAdress()" :data-clipboard-text="selfLiftingAddress">
                    <img class="addressView_right_icon" src="../../assets/images/icon_btn_duplicate_icon.png"/>
                    <span class="addressView_right_span">复制</span>
                </div>
            </div>
        </div>

        <div class="orderTop">
            <img class="list_box_left_icon" v-if="details.templateType=='1'" src='../../assets/images/img_mall_zfq.png' />
            <img class="orderTop_icon" :src="details.actImgPath" v-else />
             <div class="orderTop_right">
                 <span class="orderTop_right_span1">{{details.actName}}</span>
                 <span class="orderTop_right_span2">x{{details.exchangeNum}}</span>
                 <span class="orderTop_right_span3">{{details.changeVal}}积分</span>
             </div>

        </div>

        <div class="orderInfo">
            <div class="orderInfo_Top">
                <div class="orderInfo_Top_line"></div>
                <span class="orderInfo_Top_span">订单信息</span>
            </div>
            <div class="orderInfo_div">
                <span class="orderInfo_div_span1">下单人</span>
                <span class="orderInfo_div_span2">{{details.phone}}</span>
            </div>
            <div class="orderInfo_div">
                <span class="orderInfo_div_span1">订单编号</span>
                <span class="orderInfo_div_span2" :data-clipboard-text="details.id">{{details.id}}</span>
                <span class="orderInfo_div_span3" :data-clipboard-text="details.id" @click="copyTradeCode()"> 复制</span>
            </div>
            <div class="orderInfo_div">
                <span class="orderInfo_div_span1">兑换时间</span>
                <span class="orderInfo_div_span2">{{details.createTime}}</span>
            </div>
            <div class="orderInfo_div" v-if="details.deliveryTime">
                <span class="orderInfo_div_span1">自提时间</span>
                <span class="orderInfo_div_span2">{{details.deliveryTime}}</span>
            </div>
        </div>
        
        <!--  v-if="status==1 &&roleList.length>0 &&common.userId!=userID" -->
        <div class="footButton"  v-if ="details.actType ==1 &&( details.tradeStatus ==3 ||details.tradeStatus ==4)" >
          <div class="footButton_div1" @click="backAction()">
               <span class="footButton_span1">取消</span>
          </div>
           <div class="footButton_div"  @click="showModalAction()">
              <span class="footButton_span">核销</span>
          </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import {getMbActiveTradeById ,verifiyTrade  } from "../../utils/api";
import Clipboard from 'clipboard';
import util from '../../utils/util';
export default {
  name: "PointOrderDetails",
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  data() {
    return {
      typeList:[1,2,3,4,5,6,7,8,9,10],
      valveList:[],
      time:'',
      mbAddress:"",
      selfLiftingAddress:'',
      details:'',
      tradeId:'',
    }
  },
  created () {
      let query = this.$route.query;
      this.tradeId=query.id;
      this.getMbActiveTradeById ();

  },

  methods: {
      copyTradeCode () {
          console.log("in copyTradeCode");
        var clipboard = new Clipboard('.orderInfo_div_span3')
        clipboard.on('success', () => {
            util.showToast('复制成功')
            // 释放内存
                clipboard.destroy()
            })
      },
      copyTradeCodeAdress () {
        var clipboard = new Clipboard('.addressView_right')
        clipboard.on('success', () => {
            util.showToast('复制成功')
            // 释放内存
                clipboard.destroy()
            })
       },

       getMbActiveTradeById () {
            let params = {
                tradeId:  this.tradeId,
            }
            getMbActiveTradeById(params).then(res => {
                console.log(res)
                if (res.res.code === 10000) {
                    this.details = res.body.mbActiveTrade
                    this.selfLiftingAddress = res.body.mbActiveTrade.selfLiftingAddress
                    if (this.details.courierType === '2') {
                        this.mbAddress = res.body.mbAddress
                        if (this.details.sendTime) {
                            let timeString = new Date(this.details.sendTime.replace(/-/g, '/')).valueOf() + 15 * 1000 * 60 * 60 * 24 - (new Date()).valueOf()
                            this.time = parseInt(timeString / 1000 / 60 / 60 / 24) + '天' + parseInt(timeString / 1000 / 60 / 60 % 24, 10) + '时'
                        }
                    }
                }
            })
        },



        verifiyTradeAction(){

            let params = {
                tradeId:  this.tradeId,
                verifiyPhone:this.common.userInfo.account
            }
            var that =this
            console.log('in verifiyTrade')
            verifiyTrade(params).then(res => {
                if (res.res.code === 10000) {
                    that.$router.replace('/PointOrderWriteOffSuccess')
                    // util.showModal('',`已完成核销!`,false,'确定',()=>{
                    //     // that.$router.go(-1)
                    //     that.$router.replace('/PointOrderWriteOffSuccess')
                    // })

                }else{
                    util.showModal('', res.res.msg,false,'确定',()=>{
                       
                    })
                }
            })


        },
        backAction(){
            this.$router.go(-1)
        },
        showModalAction(){
            var that =this
            util.showModal('',`确定要核销吗?`,true,'确定',()=>{
                console.log('in 确定')
                that.verifiyTradeAction()
            })
        }

  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
    // width:100%;
    position: relative;
    background:#F3F4F6;
    .flex(column);

}
.topView{
    width:100%;
    height:150px;
    background:linear-gradient(270deg,rgba(255,176,0,1) 0%,rgba(255,114,0,1) 100%);
     display: flex;
    flex-direction: column;
    .topView_top{
        margin-left: 28px;
        margin-top: 28px;
        flex-direction: row;
         display: flex;
        .topView_top_icon{
            width: 36px;
            height: 36px;
        }
        .topView_top_span{
            margin-left: 14px;
            height:44px;
            font-size:32px;
            font-weight:500;
            color:rgba(255,255,255,1);
            line-height:44px;
        }
    }
    .topView_body{
        display: flex;
        .topView_body_span{
            margin-left: 28px;
            margin-top: 14px;
            height:36px;
            background:rgba(0,0,0,0.1);
            border-radius:8px;
            padding-left: 14px;
            padding-right: 14px;
            font-size:24px;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:36px;
        }
    }

}
.addressView{
    width: 100%;
    height:252px;
    background:rgba(255,255,255,1);
    .addressViewBG{
        margin-top: 28px;
        width: 92.54%;
        margin-left: 28px;
        height:196px;
        background:rgba(248,248,248,1);
        border-radius:8px;
        display: flex;
        flex-direction: row;
        .addressView_left{
            margin-left: 20px;
            margin-top: 30px;
            width: 516px;
            // background-color: blue;
            display: flex;
            flex-direction: column;
            .addressView_left_div{
                display: flex;
                flex-direction: row;
                .addressView_left_icon{
                    margin-top: 5px;
                    width: 24px;
                    height: 30px;
                }
                .addressView_left_span1{
                    height:40px;
                    font-size:28px;
                    margin-left: 4px;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                    line-height:40px;
                }
            }
            .addressView_left_span2{
                display: flex;
                margin-top: 14px;
                margin-left: 48px;
                width:468px;
                height:80px;
                font-size:28px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:40px;
            }
        }
        .addressView_line{
            margin-left: 28px;
            margin-right: 28px;
            margin-top: 58px;
            width:2px;
            height:80px;
            background:rgba(234,234,234,1);
        }
        .addressView_right{
            margin-left: 14px;
            display: flex;
            flex-direction: column;
            .addressView_right_icon{
                margin-top: 60px;
                width: 44px;
                height: 44px;
                // background-color: blue;
            }
            .addressView_right_span{
                margin-top: 4px;
                height:32px;
                font-size:22px;
                font-weight:400;
                color:rgba(102,102,102,1);
                line-height:32px;
            }
        }
    }
}

.orderTop{
    margin-top: 14px;
    margin-bottom: 14px;
    width: 100%;
    height:236px;
    background:rgba(255,255,255,1);
    display: flex;
    flex-direction: row;
    .orderTop_icon{
        margin-top: 28px;
        margin-left: 28px;
        // background-color: blue;
        width:240px;
        height:180px;
    }
    .orderTop_right{
         margin-top: 28px;
         margin-left: 20px;
         display: flex;
         flex-direction: column;
         .orderTop_right_span1{
            display: flex;
            width:434px;
            height:64px;
            font-size:28px;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:32px;
         }
         .orderTop_right_span2{
             margin-top: 20px;
             height:36px;
            font-size:26px;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:36px;

         }
         .orderTop_right_span3{
             margin-top: 20px;
             height:40px;
             font-size:28px;
             font-weight:500;
             color:rgba(255,126,30,1);
             line-height:40px;
         }

    }
}

.orderInfo{
    width:100% ;
    height:326px;
    background:rgba(255,255,255,1);
    flex-direction: column;
    display: flex;
    .orderInfo_Top{
        margin-top: 28px;
        margin-left: 28px;
        margin-bottom: 8px;
        flex-direction: row;
        display: flex;
        align-items: center;
        .orderInfo_Top_line{
            width:6px;
            height:24px;
            background:rgba(255,126,30,1);

        }
        .orderInfo_Top_span{
            margin-left: 14px;
            height:44px;
            font-size:32px;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:44px;

        }

    }

    .orderInfo_div{
         margin-top: 20px;
         margin-left: 28px;
         flex-direction: row;
         display: flex;
         align-items: center;
         .orderInfo_div_span1{
            height:40px;
            font-size:28px;
            font-weight:400;
            color:rgba(102,102,102,1);
            line-height:40px;
         }
         .orderInfo_div_span2{
            margin-left: 40px;
            height:40px;
            font-size:28px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:40px;

         }
         .orderInfo_div_span3{
            margin-left: 14px;
            width:96px;
            height:40px;
            border-radius:8px;
            border:1px solid rgba(218,218,218,1);
            font-size:24px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:40px;
            text-align: center;

         }

    }   

}
.footButton{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index:100;
    height: 120px;
    padding:26px 32px;
    box-sizing:border-box;
    display: flex;
    background-color: white;
    flex-direction: row;
    justify-content: space-between;
}
.footButton_div{
    width:332px;
    height:76px;
    background:rgba(23,64,218,1);
    border-radius:4px;
    display: flex;
    justify-content: center;
    align-items: center;
    .footButton_span{
        height:44px;
        font-size:32px;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:44px;
    }

}
.footButton_div1{
    width:328px;
    height:72px;
    border-radius:4px;
    display: flex;
    justify-content: center;
    align-items: center;
    border:2px solid rgba(23,64,218,1);
    .footButton_span1{
        height:44px;
        font-size:28px;
        font-weight:400;
        color:rgba(23,64,218,1);
        line-height:44px;
    }
}

</style>